/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M1.4502 4.6285A.7553.7553 0 0 0 .59 4.1866l-.1297.0419a.7553.7553 0 0 0-.4418.8603l.0418.1297 2.7994 6.595 6.5932-2.8003a.755.755 0 0 0-.4607-1.4317l-.1297.0418L4.781 9.356a9.0879 9.0879 0 0 1 .9172-2.019c1.0766-1.7604 2.7427-3.1347 4.7788-3.8358 4.7313-1.629 9.8874.8857 11.5165 5.617 1.6291 4.7312-.8857 9.8873-5.617 11.5163-2.2306.7681-4.6194.6341-6.7213-.3286a9.087 9.087 0 0 1-2.7764-1.9726.755.755 0 1 0-1.0903 1.0447 10.5968 10.5968 0 0 0 3.238 2.3008c2.4509 1.1226 5.2407 1.2791 7.8417.3835 5.5197-1.9006 8.4536-7.916 6.553-13.4358-1.9006-5.5198-7.916-8.4537-13.4358-6.553a10.5494 10.5494 0 0 0-5.8709 4.9908 10.6039 10.6039 0 0 0-.8055 1.9406L1.4502 4.6285Zm0 0-.0037.0015Z"
    clipRule="evenodd"
  />,
  'Regenerate'
);
